async function updateHeaderCartCount() {
  try {
    const response = await fetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    const cart = await response.json();

    document
      .querySelectorAll('.js-cart-item-count')
      .forEach(function(item) {
        item.innerHTML = cart.item_count;
      });

    document
      .querySelectorAll('.js-cart-item-total')
      .forEach(function(item) {
        if (
          typeof Number.prototype.toCurrency === 'function'
        ) {
          item.innerHTML = Number(cart.total_price || 0).toCurrency();
        }
      });

    document.dispatchEvent(
      new CustomEvent('cart-change', {
        detail: cart
      })
    );

    console.log('Header cart updated:', cart.item_count);

  } catch (error) {
    console.error('Header cart update error:', error);
  }
}

document.addEventListener('click', function(e) {
  const addToCartBtn = e.target.closest(
    'button[name="add"], ' +
    '.add-to-cart, ' +
    '.js-add-to-cart, ' +
    '[data-add-to-cart], ' +
    '.cart-plus'
  );

  if (!addToCartBtn) return;

  setTimeout(function() {
    const closeBtn = document.querySelector(
      '.js-cart-popup-close, .popup-cart-close'
    );

    if (closeBtn) {
      closeBtn.click();
    }
  }, 2000);
});

document.addEventListener('submit', function(e) {
  const form = e.target.closest('.js-form-add-to-cart');

  if (!form) return;

  const button = form.querySelector('.js-atc-btn');

  if (button) {
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
  }

  setTimeout(async function() {
    await updateHeaderCartCount();

    if (button) {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
    }
  }, 1000);
});